import React, { useRef, useEffect } from 'react';
import AwsFileUpload from 'views/components/core/AwsFileUpload';

export const BOUNTY_STATUS = [
  { label: 'Open', value: 'OPEN' },
  { label: 'In-progress', value: 'IN_PROGRESS' },
  { label: 'Judging', value: 'JUDGING' },
  { label: 'Closed', value: 'CLOSED' },
];

export const THEMES = [
  { label: 'Hackathon', value: 'hackathon' },
  { label: 'Challenge', value: 'challenge' },
  { label: 'Challenge Quiz', value: 'challenge-quiz' },
  { label: 'Challenge Image Tagging', value: 'challenge-image-tagging' },
  { label: 'Mentor', value: 'mentor' },
  { label: 'Challenge Online Quiz', value: 'challenge-online-quiz' },
  { label: 'Community Contest', value: 'challenge-community-contest-quiz' },
];

export const BOUNTY_TYPES = [
  { label: 'Special Quiz', value: 'SPECIAL_QUIZ' },
  { label: 'Regular Mentoring Session', value: 'REGULAR_MENTORING_SESSION' },
  { label: 'Regular Hackathon', value: 'REGULAR_HACKATHON' },
  { label: 'Community Activity', value: 'COMMUNITY_ACTIVITY' },
  { label: 'Regular Quiz', value: 'REGULAR_QUIZ' },
];

const GeneralTab = ({ editedBounty, handleInputChange, onSave, onCancel, activeTab }) => {
  // Tạo ref cho từng uploader
  const bannerRef = useRef();
  const thumbnailRef = useRef();
  const headerImageRef = useRef();

  useEffect(() => {
    if (activeTab === 'GENERAL') {
      // Thực hiện các hành động khi tab General được chọn
      console.log('General tab is active');
    }
  }, [activeTab]);

  // Hàm xử lý khi upload xong
  const handleUploadDone = (field) => (url) => {
    handleInputChange(field, url);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    try {
      // Nếu là string date (YYYY-MM-DD) thì trả về luôn
      if (typeof timestamp === 'string' && timestamp.includes('-')) {
        return timestamp;
      }
      // Nếu là timestamp thì chuyển đổi
      const date = new Date(Number(timestamp));
      if (isNaN(date.getTime())) return '';
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  };

  return (
    <div style={{ flex: 1 }}>
      <div style={{ display: 'flex', gap: 32 }}>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Name *</label>
            <input 
              value={editedBounty?.name || ''} 
              onChange={(e) => handleInputChange('name', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Banner *</label>
            <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 12 }}>
              {editedBounty?.banner && (
                <img src={editedBounty.banner} alt="Banner" style={{ width: 220, height: 73, objectFit: 'cover', borderRadius: 8, border: '1px solid #eee' }} />
              )}
              <button type="button" onClick={() => bannerRef.current.click()} style={{ padding: 6, borderRadius: 4, border: '1px solid #1976d2', background: '#fff', color: '#1976d2', cursor: 'pointer' }}>Chọn ảnh</button>
              <AwsFileUpload
                customStyle={{ display: 'none' }}
                fileRef={bannerRef}
                accept=".png, .jpg, .jpeg, .webp"
                typePattern={/^image\/(png|jpg|jpeg|webp)$/}
                maxSize={5}
                path="bounty/banner/"
                prefix="banner_"
                uploadDone={handleUploadDone('banner')}
                signals={{
                  onStart: 'UPLOAD_IMAGE',
                  onSuccess: 'UPLOAD_IMAGE_SUCCESS',
                  onFailure: 'UPLOAD_IMAGE_FAILED',
                }}
              />
            </div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
              Banner (1500 x 500, WEBP recommended) *
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Thumbnail *</label>
            <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 12 }}>
              {editedBounty?.thumbnail && (
                <img src={editedBounty.thumbnail} alt="Thumbnail" style={{ width: 140, height: 100, objectFit: 'cover', borderRadius: 8, border: '1px solid #eee' }} />
              )}
              <button type="button" onClick={() => thumbnailRef.current.click()} style={{ padding: 6, borderRadius: 4, border: '1px solid #1976d2', background: '#fff', color: '#1976d2', cursor: 'pointer' }}>Chọn ảnh</button>
              <AwsFileUpload
                customStyle={{ display: 'none' }}
                fileRef={thumbnailRef}
                accept=".png, .jpg, .jpeg, .webp"
                typePattern={/^image\/(png|jpg|jpeg|webp)$/}
                maxSize={5}
                path="bounty/thumbnail/"
                prefix="thumbnail_"
                uploadDone={handleUploadDone('thumbnail')}
                signals={{
                  onStart: 'UPLOAD_IMAGE',
                  onSuccess: 'UPLOAD_IMAGE_SUCCESS',
                  onFailure: 'UPLOAD_IMAGE_FAILED',
                }}
              />
            </div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
              Thumbnail (350 x 250, WEBP recommended) *
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Theme *</label>
            <select 
              value={editedBounty?.theme || ''} 
              onChange={(e) => handleInputChange('theme', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
            >
              <option value="">Select a theme</option>
              {THEMES.map(theme => (
                <option key={theme.value} value={theme.value}>{theme.label}</option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: 16, display: 'flex', gap: 16 }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: 600 }}>Is Visible *</label>
              <div style={{ marginTop: 8 }}>
                <input 
                  type="radio" 
                  checked={editedBounty?.isVisible === true} 
                  onChange={() => handleInputChange('isVisible', true)}
                /> Yes
                <input 
                  type="radio" 
                  checked={editedBounty?.isVisible === false} 
                  onChange={() => handleInputChange('isVisible', false)}
                  style={{ marginLeft: 24 }} 
                /> No
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: 600 }}>Required Proposal</label>
              <div style={{ marginTop: 8 }}>
                <input 
                  type="radio" 
                  checked={editedBounty?.proposalRequired === true} 
                  onChange={() => handleInputChange('proposalRequired', true)}
                /> Yes
                <input 
                  type="radio" 
                  checked={editedBounty?.proposalRequired === false} 
                  onChange={() => handleInputChange('proposalRequired', false)}
                  style={{ marginLeft: 24 }} 
                /> No
              </div>
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Type *</label>
            <select 
              value={editedBounty?.type || ''} 
              onChange={(e) => handleInputChange('type', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
            >
              <option value="">Select a type</option>
              {BOUNTY_TYPES.map(type => (
                <option key={type.value} value={type.value}>{type.label}</option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Maximum members</label>
            <input 
              value={editedBounty?.slots || ''} 
              onChange={(e) => handleInputChange('slots', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
            />
          </div>
        </div>
        <div style={{ flex: 1, minWidth: 320 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Description *</label>
            <input 
              value={editedBounty?.description || ''} 
              onChange={(e) => handleInputChange('description', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Header Image</label>
            <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 12 }}>
              {editedBounty?.emailHeaderImage && (
                <img src={editedBounty.emailHeaderImage} alt="Header" style={{ width: 320, height: 180, objectFit: 'cover', borderRadius: 8, border: '1px solid #eee' }} />
              )}
              <button type="button" onClick={() => headerImageRef.current.click()} style={{ padding: 6, borderRadius: 4, border: '1px solid #1976d2', background: '#fff', color: '#1976d2', cursor: 'pointer' }}>Chọn ảnh</button>
              <AwsFileUpload
                customStyle={{ display: 'none' }}
                fileRef={headerImageRef}
                accept=".png, .jpg, .jpeg, .webp"
                typePattern={/^image\/(png|jpg|jpeg|webp)$/}
                maxSize={5}
                path="bounty/header/"
                prefix="header_"
                uploadDone={handleUploadDone('emailHeaderImage')}
                signals={{
                  onStart: 'UPLOAD_IMAGE',
                  onSuccess: 'UPLOAD_IMAGE_SUCCESS',
                  onFailure: 'UPLOAD_IMAGE_FAILED',
                }}
              />
            </div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Current Status *</label>
            <select 
              value={editedBounty?.status || ''} 
              onChange={(e) => handleInputChange('status', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
            >
              <option value="">Select a status</option>
              {BOUNTY_STATUS.map(status => (
                <option key={status.value} value={status.value}>{status.label}</option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Registration Closed Date</label>
            <input 
              value={formatDate(editedBounty?.startDate)} 
              onChange={(e) => handleInputChange('startDate', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
              type="date"
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Submission Deadline</label>
            <input 
              value={formatDate(editedBounty?.endDate)} 
              onChange={(e) => handleInputChange('endDate', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
              type="date"
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Close Date</label>
            <input 
              value={formatDate(editedBounty?.closedDate)} 
              onChange={(e) => handleInputChange('closedDate', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
              type="date"
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: 600 }}>Maximum teams</label>
            <input 
              value={editedBounty?.registerLimited || ''} 
              onChange={(e) => handleInputChange('registerLimited', e.target.value)}
              style={{ 
                width: '100%', 
                padding: 10, 
                marginTop: 6, 
                border: '1px solid #ccc', 
                borderRadius: 6,
                background: '#fff'
              }} 
            />
          </div>

          {/* Quiz related fields */}
          {['challenge-quiz', 'challenge-online-quiz', 'challenge-community-contest-quiz'].includes(editedBounty?.theme) && (
            <>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 600 }}>Quiz Link</label>
                <input 
                  value={editedBounty?.quizLink || ''} 
                  onChange={(e) => handleInputChange('quizLink', e.target.value)}
                  style={{ 
                    width: '100%', 
                    padding: 10, 
                    marginTop: 6, 
                    border: '1px solid #ccc', 
                    borderRadius: 6,
                    background: '#fff'
                  }} 
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 600 }}>Solution Quiz Link</label>
                <input 
                  value={editedBounty?.solutionQuizLink || ''} 
                  onChange={(e) => handleInputChange('solutionQuizLink', e.target.value)}
                  style={{ 
                    width: '100%', 
                    padding: 10, 
                    marginTop: 6, 
                    border: '1px solid #ccc', 
                    borderRadius: 6,
                    background: '#fff'
                  }} 
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 600 }}>Leaderboard Quantity</label>
                <input 
                  type="number"
                  value={editedBounty?.leaderBoardQuantity || ''} 
                  onChange={(e) => handleInputChange('leaderBoardQuantity', e.target.value)}
                  style={{ 
                    width: '100%', 
                    padding: 10, 
                    marginTop: 6, 
                    border: '1px solid #ccc', 
                    borderRadius: 6,
                    background: '#fff'
                  }} 
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontWeight: 600 }}>Short URL</label>
                <input 
                  value={editedBounty?.shortUrl || ''} 
                  onChange={(e) => handleInputChange('shortUrl', e.target.value)}
                  style={{ 
                    width: '100%', 
                    padding: 10, 
                    marginTop: 6, 
                    border: '1px solid #ccc', 
                    borderRadius: 6,
                    background: '#fff'
                  }} 
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 24, justifyContent: 'flex-start' }}>
        <button
          onClick={onSave}
          style={{
            padding: '8px 16px',
            background: '#4caf50',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer'
          }}
        >
          Save
        </button>
        <button
          onClick={onCancel}
          style={{
            padding: '8px 16px',
            background: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer'
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default GeneralTab; 